import styled, { css } from 'styled-components';
import tw from 'twin.macro';

import { BlueTickIcon } from '../../icons/BlueTickIcon';

export const Label = styled.span`
  ${tw`text-lg leading-7 font-semibold text-blue-gray-700 mb-3 mt-2 self-start`}
  @media (max-width: 768px) {
    ${tw`leading-5 font-medium text-blue-gray-700 self-start`}
  }
`;

export const SelectWebinarSlotModalViewContainer = styled.div`
  ${tw`focus:outline-none self-start w-full`}
`;

export const ErrorText = styled.span`
  ${tw`text-xs leading-4 font-semibold text-lipstick`};
  border: solid 1px transparent;
`;

export const LabelAndCloseIconWrapper = styled.div`
  ${tw`flex justify-between items-center`}
`;

export const DayLabel = styled.span`
  ${tw`text-base leading-6 font-semibold text-blue-gray-700`}

  @media (max-width: 768px) {
    ${tw`text-base font-medium`}
  }
`;

export const OptionsContainer = styled.div`
  ${tw`flex flex-wrap mt-3 `}
`;

const selectedStyles = css`
  ${tw`text-blue-600 border-DEFAULT border-solid border-blue-600`};
`;

export const Option = styled.button`
  ${tw`text-sm  leading-5 w-245px  font-medium text-blue-gray-500 border-DEFAULT border-solid border-blue-gray-300 mr-4 mb-4 px-36px flex items-center justify-center py-2 focus:outline-none cursor-pointer rounded-44px`}
  ${(props) => (props.isSelected ? selectedStyles : tw``)}
 
   @media (min-width:1300px) {
    ${tw`px-20px w-219px `}
  }
`;

export const StyledTickIcon = styled(BlueTickIcon)``;

export const Divider = styled.div`
  ${tw`mt-2 mb-4 bg-blue-gray-300 h-px`}
`;

export const TickIconContainer = styled.div`
  ${tw`mr-1`}
  width: ${(props) => props.width}px;
`;

export const SlotOptionText = styled.span`
  ${(props) => (props.isSelected ? tw`` : tw`mr-20px`)}
`;

export const TimeSlotsContainer = styled.div``;

export const FieldContainer = styled.div`
  width: 100%;

  .radioGroupLabelClassName {
    ${tw`mb-2`}
  }
  .radioButtonClassName {
    ${tw`mb-2`};
    width: calc(50% - 12px);
  }

  ${(props) => props.css}
`;
export const radioWrapperStyles = css`
  ${tw`flex-wrap`}
`;

export const SlotCard = styled.button<{ isSelected: boolean }>`
  ${tw`flex items-center justify-center py-2 px-3 rounded-lg border border-solid transition-all duration-200 mr-4 mb-4 focus:outline-none`}

  ${(props) =>
    props.isSelected
      ? tw`bg-blue-gray-100 border-red-800 text-blue-gray-600`
      : tw`bg-white border-blue-gray-300 text-blue-gray-600 hover:border-blue-gray-500 hover:text-blue-gray-700`}
`;

export const SlotTime = styled.span`
  color: #475569;
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  font-family: Inter;
`;

export const SlotCardsContainer = styled.div`
  ${tw`flex flex-wrap mt-4`}
`;
